import { render, staticRenderFns } from "./NgPasswd.vue?vue&type=template&id=80a309c0"
import script from "./NgPasswd.vue?vue&type=script&lang=js"
export * from "./NgPasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports